import type { components } from '@/api/schema';
import { asArray, asRecord } from '@/lib/json';

type DeployCheck = components['schemas']['DeployCheck'];
type DeployCheckResult = components['schemas']['DeployCheckResult'];

/** A failing check with severity "warning" does not block the deploy; any failing "error" does (08 §3). */
export function isBlocking(c: DeployCheck): boolean {
  return !c.ok && c.severity !== 'warning';
}

export function canDeploy(result: DeployCheckResult | undefined): boolean {
  return !!result && result.checks.every((c) => !isBlocking(c));
}

export interface Branch {
  id: string;
  name: string;
}

/** Branches from the cached jde tenant config (03 §3); used for deployment scope targeting. */
export function branchesFromConfig(cfg: unknown): Branch[] {
  return asArray(asRecord(cfg)['branches'])
    .map((b) => asRecord(b))
    .filter((b) => typeof b['id'] === 'string')
    .map((b) => ({ id: b['id'] as string, name: typeof b['name'] === 'string' ? (b['name'] as string) : (b['id'] as string) }));
}

/** Request body for POST …/deployments: empty branch list = all branches; empty start = now. */
export function buildDeployment(version: number, branches: string[], startAt: string): components['schemas']['CreateDeploymentRequest'] {
  return {
    version,
    scope: (branches.length > 0 ? { branches } : {}) as never,
    schedule: (startAt ? { startAt: new Date(startAt).toISOString() } : {}) as never,
  };
}
